import api from './config';

interface BrandManagementData {
    brand_id: string;
    brand_name: string;
    manager_name: string;
    position_type: string;
}

export const brandService = {
    async getUserBrandInfo(): Promise<BrandManagementData[]> {
        const response = await api.get<BrandManagementData[]>('/brand/user-brand');
        return response.data;
    }
}; 